import axiosInstance from "./axiosInstance";
import EntitiesResponse from "../types/EntitiesResponse";
import NameRequest from "../types/NameRequest";
import MutationResponse from "../types/MutationResponse";

export const fetchCities = async (params: { name?: string } = {}): Promise<EntitiesResponse | void> => {
    return axiosInstance.get<EntitiesResponse>("/cities", { params })
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const postCity = async (request: NameRequest): Promise<MutationResponse | void> => {
    return axiosInstance.post<MutationResponse>("/cities", request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const editCity = async (id: number, request: NameRequest): Promise<MutationResponse | void> => {
    return axiosInstance.patch<MutationResponse>(`/cities/${id}`, request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const deleteCity = async (id: number): Promise<MutationResponse | void> =>
    axiosInstance.delete<MutationResponse>(`/cities/${id}`)
        .then(response => response.data)
        .catch(error => error.response.data)
